import '@shoelace-style/shoelace/dist/components/tag/tag.js';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { WLC_BASE_PATH, WLC_PRODUCT_NAME } from '../../../../constants';
import { DirtyFormController } from '../../../../controllers/dirty-form-controller';
import styles from '../menu.styles.scss';

export const SECRETS_MENU_TAG = 'platform-secrets-menu' as const;
/**
 * Default Smop menu.
 */
@customElement(SECRETS_MENU_TAG)
export class SecretsProductMenu extends LitElement {
  static override styles = [styles];

  dirtyFormController = new DirtyFormController(this);

  override render() {
    return html`
      <menu>
        <li>
          <a href=${WLC_BASE_PATH}>${WLC_PRODUCT_NAME}</a>
        </li>
      </menu>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [SECRETS_MENU_TAG]: SecretsProductMenu;
  }
}
